export default "__VITE_ASSET__pepMouRA__"